import { render, staticRenderFns } from "./CommissionModel.vue?vue&type=template&id=f4cba3e6&scoped=true&"
import script from "./CommissionModel.vue?vue&type=script&lang=js&"
export * from "./CommissionModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cba3e6",
  null
  
)

export default component.exports